import { InheritanceStatus, Slug } from "../Shared/Shared.Interfaces";

export enum PromptType {
  TEXT = "text",
  STRUCTURED = "structured", 
  SEARCH = "search"
}

export interface PromptInterface {
  id?: number;
  slug: string;
  orgId: number;
  inheritance?: InheritanceStatus;
  name: string;
  text: string;
  type: PromptType;
  schema?: string;
  mapping?: string;
}

export enum PromptStackItemType {
  PROMPT = "prompt",
  TEXT = "text",
  PREVIOUS_MESSAGES = "previous_messages",
}

export type PromptStackItem = PromptStackItem_PROMPT | PromptStackItem_TEXT | PromptStackItem_PREVIOUS_MESSAGES;

export interface PromptStackItem_PROMPT {
  id: string;
  type: PromptStackItemType.PROMPT;
  promptSlug: Slug;
}

export interface PromptStackItem_TEXT {
  id: string;
  type: PromptStackItemType.TEXT;
  text: string;
}

export interface PromptStackItem_PREVIOUS_MESSAGES {
  id: string;
  type: PromptStackItemType.PREVIOUS_MESSAGES;
  numberOfMessagesToLoad: number;
}

// Helper types for enhanced prompt functionality
export interface StructuredPromptData {
  id: number;
  name: string;
  slug: string;
  type: PromptType.STRUCTURED;
  schema: string;
  mapping: string;
}

export interface SearchPromptData {
  id: number;
  name: string;
  slug: string;
  type: PromptType.SEARCH;
  schema: string;
  mapping: string;
}

export interface TextPromptData {
  id: number;
  name: string;
  slug: string;
  type: PromptType.TEXT;
  text: string;
}

export type EnhancedPromptData = StructuredPromptData | SearchPromptData | TextPromptData;

// Validation helpers
export interface PromptValidationResult {
  isValid: boolean;
  errors: string[];
}

export interface PromptSchemaValidation {
  hasRequiredFields: boolean;
  isValidJson: boolean;
  errors: string[];
}

export interface PromptMappingValidation {
  isValidJson: boolean;
  mappingMatchesSchema: boolean;
  errors: string[];
}
